<template>
  <b-modal :id="modalid" @ok="ok" @cancel="cancel">
    <div slot="modal-header">
      <!--b-icon icon="exclamation-triangle-fill" class='warning' /-->
      {{ headerText }}
    </div>
    <b-icon icon="exclamation-triangle-fill" class='warning' />
    <div class='confirm'>{{ messageText }}</div>
    <div class="id">{{ itemid }}</div>

    <div slot="modal-footer">
      <!--
      <p-button type="default" size="sm" outline @click="cancel">
        {{ $t('button.cancel') }}
      </p-button>
      <p-button type="danger" size="sm" outline @click="ok">
        <i class="fa fa-times"></i>{{ $t('button.remove') }}
      </p-button>
      -->
      <t-button type="cancel" @click="cancel"></t-button> 
      <t-button type="rm" @click="ok"></t-button> 

    </div>
  </b-modal>
</template>

<script>


export default {
  name: 'DeleteModal',
  props: {
    itemid: { type: String },
    modalid: { type: String, default: 'delete-modal' },
    title: { type: String, default: null },
    message: { type: String, default: null },
  },
  computed: {
    headerText(){
      return this.title ? this.title : this.$t('alert.delete.confirm');
    },
    messageText(){
      return this.message ? this.message : this.$t('alert.delete.confirmation');
    }

  },
  methods: {
    getTitle() {
      return this.title ? this.title : this.$t('alert.delete.confirm');
    },
    getMessage() {
      if (this.message) {
        return this.message
      }
      return this.$t('alert.delete.confirm')
    },
    ok() {
      this.$emit('ok', this.itemid)
      this.$bvModal.hide(this.modalid)
    },
    cancel() {
      this.$emit('cancel', this.itemid)
      this.$bvModal.hide(this.modalid)
    },
    show() {
      this.$bvModal.show(this.modalid)
    },
  },
}
</script>

<style lang="scss">

#delete-modal {
  .modal-dialog {
    width: 500px;
   
  }
  .modal-content {
    border-radius: 2px;
    box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.3);

    border: 10px solid #a0283e;

    text-align: center;


     .b-icon {
        &.warning {
          font-size: 50px;
          color: #a0283e;
          margin-bottom: 20px;
        }
      }

    .modal-header {
      background: #a0283e;
      color: #fff;;
      
      padding: 0 10px 10px 10px;
      border-radius: 0;

      font-size: 16px;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }


    .modal-body {
       padding: 30px;
       font-weight: bold;

       .id {
          margin-top: 20px;
          color: #a0283e;
        }
    }

    .modal-footer {
      justify-content: flex-start;
      padding: 15px 0 15px 110px;
    }
  }


}








/*
button i {
  margin-right: 5px;
}

.modal-dialog {
  width: 400px;
}
*/

</style>

<style>
/*
.danger {
  background: red;
  color: white;
}

#delete-modal .modal-dialog {
  width: 400px;
}

#delete-modal .modal-content {
  border-radius: 5px;
  text-align: center;
}

#delete-modal .modal-header {
  color: #f15e5e;
  padding-top: 40px;
}

#delete-modal .modal-footer {
  justify-content: center;
  padding-bottom: 25px;
}

#delete-modal .modal-footer button {
  margin: 10px 5px;
}
*/
</style>
